"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _difference = _interopRequireDefault(require("./difference.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return a version of the array that does not contain the specified value(s).
var _default = exports.default = (0, _restArguments.default)(function (array, otherArrays) {
  return (0, _difference.default)(array, otherArrays);
});